/** A local view command only when there is no other content to send. */
export function isTerminalQuit(text: string, hasAttachments = false, hasMentions = false) {
  return !hasAttachments && !hasMentions && /^(?:\/quit|quit)$/i.test(text.trim());
}
